export const roles = {
  menu: ["Admins", "Menu-manager", "Location-manager"],
  menu_advanced: ["Admins", "Menu-manager"],
  menuAddProduct: ["Admins", "Menu-manager", "Location-manager"],
  promo: ["Admins", "Menu-manager", "Location-manager"],
  attributeGroup: ["Admins", "Menu-manager"],
  configureMenu: ["Admins", "Location-manager", "Menu-manager"],
  configureIIKOMenu: ["Admins", "Location-manager"],
  location: ["Admins"],
  analytics: ["Admins", "Location-manager"],
  order: ["Admins", "Location-manager"],
  stopList: ["Admins", "Location-manager"],
  stopListBalance: ["Admins", "Location-manager"],
  timeSetting: ["Admins", "Location-manager"],
  uploadMenu: ["Admins", "Menu-manager", "Location-manager"],
  matchMenu: ["Admins", "Menu-manager"],
  createMenuSuccess: ["Admins", "Menu-manager"],
  publicationMenu: ["Admins", "Menu-manager", "Location-manager"],
  setWoltPromoStatus: ["Admins"],
  callCenter: ["Callcenter"],
  posSettings: ["Admins"],
  access: ["Admins"],
  cron: ["Admins", "Location-manager"],
};
